exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lozengeBubbles {\n  text-align: center; }\n\n.lozenge {\n  float: left;\n  text-align: center;\n  cursor: pointer;\n  border: #888AA0;\n  color: #757575;\n  font-size: 20px;\n  box-shadow: 1.5px 2px 1.5px 2px #E7E7E7;\n  margin: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 50px 50px; }\n\n.closeLozenge {\n  cursor: pointer;\n  border: none;\n  color: #888AA0; }\n", ""]);

// exports
